export function generateGuid() {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);

  array[6] = (array[6] & 0x0f) | 0x40; // Version 4
  array[8] = (array[8] & 0x3f) | 0x80; // Variant 10

  const guid = [...array].map((b, i) => {
    const hex = b.toString(16).padStart(2, '0');
    if (i === 4 || i === 6 || i === 8 || i === 10) {
      return '-' + hex;
    }
    return hex;
  }).join('');

  return guid;
}

/**
 * Sanitizes a file or folder name to ensure it only contains alphanumeric UTF-8 characters
 * and replaces spaces with hyphens
 * 
 * @param {string} name - The original file or folder name
 * @returns {string} - The sanitized name
 */
export const sanitizeFileName = (name) => {
  if (!name) return '';
  
  let sanitized = name.trim().replace(/\s+/g, '-');
  sanitized = sanitized.replace(/[^\p{L}\p{N}_\-\.]/gu, '');
  sanitized = sanitized.replace(/--+/g, '-').replace(/^-+|-+$/g, '');
  if (!sanitized) {
    return 'untitled';
  }
  return sanitized;
};

/**
 * Sanitizes a folder name to ensure it only contains alphanumeric UTF-8 characters,
 * replaces spaces with hyphens, and removes any dots (preventing extensions in folder names)
 * 
 * @param {string} name - The original folder name
 * @returns {string} - The sanitized folder name
 */
export const sanitizeFolderName = (name) => {
  if (!name) return '';
  
  let sanitized = name.trim().replace(/\s+/g, '-');
  sanitized = sanitized.replace(/\./g, '');
  sanitized = sanitized.replace(/[^\p{L}\p{N}_\-]/gu, '');
  sanitized = sanitized.replace(/--+/g, '-').replace(/^-+|-+$/g, '');
  if (!sanitized) {
    return 'untitled-folder';
  }
  return sanitized;
};

// Define the debounce function
export const debounce = function (func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};


export const saveAs = function (filename, content, contentType) {
  // Create a Blob object with the content and the specified content type
  var blob = new Blob([content], {type: contentType});

  // Create a URL representing the Blob object
  var url = URL.createObjectURL(blob);

  // Create an anchor element
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;

  // Append the anchor to the body (this is necessary for Firefox)
  document.body.appendChild(a);

  // Trigger a click event on the anchor
  a.click();

  // Remove the anchor from the body
  document.body.removeChild(a);

}
